import { render, staticRenderFns } from "./OpenPay.vue?vue&type=template&id=9a6be39a&scoped=true&"
import script from "./OpenPay.vue?vue&type=script&lang=js&"
export * from "./OpenPay.vue?vue&type=script&lang=js&"
import style0 from "./OpenPay.vue?vue&type=style&index=0&id=9a6be39a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6be39a",
  null
  
)

export default component.exports